"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrushedByAnElephantAbilityHandler = exports.CrushedByAnElephantActorAbilityFactory = exports.CrushedByAnElephantAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class CrushedByAnElephantAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CrushedByAnElephant;
        this.__typeName = "CrushedByAnElephant";
    }
}
exports.CrushedByAnElephantAbilityArgs = CrushedByAnElephantAbilityArgs;
let CrushedByAnElephantActorAbilityFactory = class CrushedByAnElephantActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CrushedByAnElephant", "AllEnemies", 0);
    }
};
CrushedByAnElephantActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CrushedByAnElephant")
], CrushedByAnElephantActorAbilityFactory);
exports.CrushedByAnElephantActorAbilityFactory = CrushedByAnElephantActorAbilityFactory;
let CrushedByAnElephantAbilityHandler = class CrushedByAnElephantAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            abilityKey: "CrushedByAnElephant",
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 60)
                ]
            })),
            onHit: (sequence, { targetId }) => container.applyDebuff({
                sequence,
                attackerId: ability.invokerId,
                targetId,
                duration: Duration_1.Duration.Permanent,
                supernatural: true,
                effect: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageImmunity, 1)
            })
        });
    }
};
CrushedByAnElephantAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CrushedByAnElephant)
], CrushedByAnElephantAbilityHandler);
exports.CrushedByAnElephantAbilityHandler = CrushedByAnElephantAbilityHandler;
